
<template>
  <div class="dive">
    <div class="dive__text subtitle--small">
      <span ref="text" class="ff-dr ft-16">DIVE DEEPER</span>
    </div>
    <span ref="line" class="dive__line"></span>
  </div>
</template>

<script>
import { TimelineMax, Power3 } from 'gsap/TweenMax'
import scroll from '@/oceanSchool/scroll.js'
export default {
  beforeDestroy () {
    scroll.unbind('dive-deeper')

    this.tlDiveDeeper && this.tlDiveDeeper.kill()
    this.tlDiveDeeper = null
    this.text = null
    this.line = null
  },

  mounted () {
    this.$nextTick(() => {
      this.text = this.$refs.text
      this.line = this.$refs.line
      this.timelineDiveDeeper()
      this.play()
    })
  },

  methods: {
    start () {
      this.reverse()
    },

    timelineDiveDeeper () {
      this.tlDiveDeeper = new TimelineMax({
        paused: true
      })

      this.tlDiveDeeper.to(this.text, 0.6, {
        css: {
          y: '-108%'
        },
        ease: Power3.easeOut
      }).to(this.line, 0.5, {
        css: {
          scaleY: 0
        },
        ease: Power3.easeOut
      }, '-=0.3')

      scroll.bind('dive-deeper', this.scrollDiveDeeper)
    },

    play () {
      this.tlDiveDeeper.timeScale(1)
      this.tlDiveDeeper.play()
    },

    reverse () {
      this.tlDiveDeeper.timeScale(1.2)
      this.tlDiveDeeper.reverse()
    },

    scrollDiveDeeper () {
      window.currentScrollTop > 0 ? this.play() : this.reverse()
    }
  }
}
</script>
